import { render, staticRenderFns } from "./UpdateAtlasPlatform.vue?vue&type=template&id=47882759"
import script from "./UpdateAtlasPlatform.vue?vue&type=script&lang=ts"
export * from "./UpdateAtlasPlatform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports